/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicOrder from './paramedic-order';
import ParamedicOrderDetail from './paramedic-order-detail';
import ParamedicOrderUpdate from './paramedic-order-update';
import ParamedicOrderDeleteDialog from './paramedic-order-delete-dialog';

const ParamedicOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicOrder />} />
    <Route path="new" element={<ParamedicOrderUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicOrderDetail />} />
      <Route path="edit" element={<ParamedicOrderUpdate />} />
      <Route path="delete" element={<ParamedicOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicOrderRoutes;
